import React from 'react';
import { TextAlign } from '../../../types';
import * as styles from '../PageSection.style';

export interface PageSectionBlockProps {
  textAlign?: TextAlign,
  noSpacing?: boolean,
  children: React.ReactNode,
}

const PageSectionBlock: React.FC<PageSectionBlockProps> = ({
  children,
  noSpacing = false,
  textAlign = TextAlign.LEFT,
}) => (
  <div
    css={styles.block}
    $noSpacing={noSpacing}
    $textAlign={textAlign}
  >
    {children}
  </div>
);

export default PageSectionBlock;
